import { IUser } from '.'
import { ObjectsFactory, Model } from './core'

export interface INote {
  id: number
  created_at: string
  updated_at: string
  create_by: string
  update_by: string
  data: NoteData
  user_id: number
  create_user: IUser
}

export interface NoteData {
  message?: string | null
}

const modelConfig = {
  path: '/note'
}

export class Note extends Model {
  static queryKeys = {
    paginate: 'NOTES_PAGINATE_QUERY',
    findOne: 'NOTES_FIND_ONE_QUERY'
  }

  static objects = ObjectsFactory.factory<INote>(modelConfig, this.queryKeys)

  // static getNotesSelectOptions(notes: INote[] | undefined) {
  //   if (!notes) return []

  //   return notes.map(item => ({
  //     value: item.id,
  //     label: item.data
  //   }))
  // }
  static getDetailById(id: number) {
    return this.api.get<INote>({
      url: `/note/${id}`
    })
  }
}
Note.setup(modelConfig)
